import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { CODE_HOME } from '../lib/chatNavigation'
import { openReadyCodeConversation } from '../lib/codeReadyConversations'

export default function NewCodeConversationPage() {
  const { agent } = useParams()
  const [params, setParams] = useSearchParams()
  const navigate = useNavigate()
  const qc = useQueryClient()
  const [fallbackId] = useState(() => crypto.randomUUID())
  const [error, setError] = useState<string | null>(null)
  const launchId = params.get('launch_id')
  const validId = !!launchId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(launchId)
  const validAgent = agent === 'codex' || agent === 'claude'
  useEffect(() => {
    if (!launchId) setParams({ launch_id: fallbackId }, { replace: true })
  }, [launchId, fallbackId, setParams])
  useEffect(() => {
    if (!validAgent || !validId || !launchId) return
    let active = true
    void openReadyCodeConversation(qc, agent, launchId).then((target) => {
      if (active) navigate(target, { replace: true })
    }).catch((failure: unknown) => {
      if (active) setError(failure instanceof Error ? failure.message : 'Could not open the conversation')
    })
    return () => { active = false }
  }, [agent, validAgent, launchId, validId, qc, navigate])
  if (!validAgent || (launchId && !validId) || error) {
    return <div className="grid h-full place-items-center px-6 text-center"><div>
      <p role="alert" className="mb-4 text-sm">{error ?? 'Invalid Code shortcut'}</p>
      <Link to={CODE_HOME} replace className="text-sm underline">Show Code conversations</Link>
    </div></div>
  }
  return <div className="grid h-full place-items-center text-sm text-stone-500">Opening conversation...</div>
}
